import styled, { css } from 'styled-components'

const designerCSS = css`
  /*! CSS Used from: http://yolo.tino.me/app_v3/resources/css/games_panel.css */
  &.profile_wrapper * {
    display: flex;
    transition: all 0.5s;
  }
  &.profile_wrapper {
    display: flex;
    flex-flow: row;
    padding: 0 0 0 15px;
    align-items: center;
    position: fixed;
    height: 50px;
    z-index: 2;
    top: 0;
    left: 0;
    background: var(--panel-profile-background);
    border-radius: 0 10px 0 0;
    transition: all 0.5s;
  }
  #game_main_area .profile_avatar img {
    width: 30px;
    border-radius: 8px;
  }
  &.profile_wrapper .profile_name {
    padding: 0 0 0 10px;
    line-height: 100%;
    font-size: 0.9rem;
    font-weight: 600;
    align-items: center;
  }
  &.profile_wrapper .profile_name span {
    border-bottom: 1px dotted hsla(0, 0%, 100%, 0.4);
  }
  &.profile_wrapper {
    width: 90px;
  }
  &.profile_wrapper.open .profile_name {
    opacity: 1;
  }
  &.profile_wrapper .profile_name {
    opacity: 0;
  }
  &.profile_wrapper.open {
    max-width: 350px;
    width: 350px;
  }
  /*! CSS Used from: http://yolo.tino.me/app_v3/resources/css/lb_bids_stats.css */
  @media (max-width: 1600px) {
    &.profile_wrapper.open {
      max-width: 250px;
      width: 250px;
    }
  }
  /*! CSS Used from: http://yolo.tino.me/app_v3/resources/css/res.css */
  @media (min-width: 1601px) {
    &.profile_wrapper {
      top: 70px;
    }
  }
  @media (max-width: 800px) {
    &.profile_wrapper {
      width: 50px;
      background: none;
    }
    &.profile_wrapper.open {
      width: 360px;
      background: hsl(214, 18%, 15%);
      border-radius: 0 10px 0 0;
    }
    &.profile_wrapper.open .profile_avatar {
      display: block;
    }
    &.profile_wrapper .profile_avatar {
      display: none;
    }
  }
`

const makePanelFloatCSS = css`
  @media (max-width: 1600px) {
    &.profile_wrapper.open {
      max-width: 350px;
      width: 350px;
    }
  }
`

const developerCSS = css`
  &.profile_wrapper .user {
    cursor: pointer;
  }
`

export const ProfilePanelHeaderCSS = styled.div`
  ${designerCSS}
  ${makePanelFloatCSS}
  ${developerCSS}
`
